import round from 'lodash/round'

export const percentageIncrease = (amount, percentage) => {
  return round(amount + (amount * percentage / 100), 2)
}

export const amountInCents = (amount) => {
  return round(amount * 100)
}

export const percentageOf = (amount, percentage) => {
  return round(amount * percentage / 100, 2)
}
